<template>
  <div class="details-view kef-export-order">
    <div class="main-contain">
      <el-form class="section" label-position="right" label-width="120px" label-suffix=":">
        <div class="app-main-inner-row" style="flex-direction: column">
          <el-divider content-position="left">{{ $t('SystemDocking.ExportSettings') }}</el-divider>
          <el-form-item :label="$t('SystemDocking.BusinessType')">
            <el-radio-group v-model="form.type">
              <div style="line-height: 28px">
                <span style="display: inline-block;font-size: 14px;margin-right: 5px">{{ $t('SystemDocking.OceanFreight') }}</span>
                <el-radio label="SE">{{ $t('SystemDocking.OceanExport') }}</el-radio>
                <el-radio label="SI">{{ $t('SystemDocking.OceanImportdirectOrder') }}</el-radio>
              </div>
              <div style="line-height: 28px;">
                <span style="display: inline-block;font-size: 14px;margin-right: 5px">{{ $t('SystemDocking.AirFreight') }}</span>
                <el-radio label="AE">{{ $t('SystemDocking.AirExport') }}</el-radio>
                <el-radio label="AI">{{ $t('SystemDocking.AirImportdirectOrder') }}</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="flex-direction: column">
          <el-divider content-position="left">{{ $t('SystemDocking.ExportConditions') }}</el-divider>
          <el-row>
            <el-col :span="18">
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.BusinessDate')">
                  <el-date-picker v-model="form.EtdDate" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.OperationDate')">
                  <el-date-picker v-model="form.customDate" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="18">
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.BusinessCreationDate')">
                  <el-date-picker v-model="form.dateCreated" type="daterange" style="width: 100%" value-format="yyyy-MM-dd" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.BusinessStatus')">
                  <el-select v-model="form.jobState" multiple>
                    <el-option v-for="state in jobState" :key="state.code" :label="state.chineseName" :value="state.code" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="18">
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.Operation')">
                  <cargo-user-select
                    :method-params="{category:'role',shape:'op'}"
                    :default-value="form.operatorId"
                    @change="p=>{form.operatorId=p.value}"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.BusinessNumber')">
                  <el-input v-model="form.jobNo" />
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="18">
              <el-col v-if="form.type === 'AE' || form.type === 'SE'" :span="12">
                <el-form-item :label="$t('SystemDocking.DirectOrder')">
                  <el-radio-group v-model="form.mblOnly">
                    <el-radio label="">{{ $t('SystemDocking.All') }}</el-radio>
                    <el-radio :label="1">{{ $t('SystemDocking.Yes') }}</el-radio>
                    <el-radio :label="0">{{ $t('SystemDocking.No') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.OperatingBranch')">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office"
                    multiple
                    :default-multiple-value="form.branchId"
                    @parentCallBack="p=>form.branchId=[...p.value]"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('SystemDocking.MasterBillNumber')">
                  <el-input v-model="form.mbl" />
                </el-form-item>
              </el-col>
              <el-col v-if="form.type === 'SE' || form.type === 'SI'" :span="12">
                <el-form-item :label="$t('SystemDocking.MasterBillSerialNumber')">
                  <el-input v-model="form.serialNo" />
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item>
                <div style="display: flex;justify-content: space-between">
                  <span class="orange">{{ $t('SystemDocking.ReminderExportedAtOnce1000') }}</span><el-button type="primary" @click="handleExport">{{ $t('SystemDocking.ConfirmExport') }}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  STATE_OPERATING,
  STATE_PRE_COMMIT,
  STATE_COMMITED,
  STATE_VERIFIED,
  AI
} from '@/class/cargo/model/parameters/SystemConstants.js'
import { exportOrder, exportOrderCount, getFileId } from '@/api/systemDocking/kef.js'
import { getLoading } from '@/utils/utilBaseElement'
import convertResToBlob from '@/utils/convertResToBlob'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import CargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { v4 as uuidv4 } from 'uuid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'

export default {
  name: 'TabBatchExportOrder',
  components: { CargoAdvanceSelect, CargoOfficeSelect, CargoUserSelect },
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      selectTypeNames: TYPE_NAMES,
      jobState: [STATE_OPERATING, STATE_PRE_COMMIT, STATE_COMMITED, STATE_VERIFIED],
      form: {
        type: 'SE',
        EtdDate: [today, today],
        customDate: '',
        dateCreated: '',
        jobNo: '',
        mblOnly: '',
        operatorId: '',
        branchId: [this.$store.getters.currentOfficeId],
        jobState: [0],
        mbl: '',
        serialNo: ''
      },
      loading: null,
      fileFlagNo: '',
      countResult: {}
    }
  },
  methods: {
    handleExport() {
      const { type, EtdDate, customDate, jobState, dateCreated,
        jobNo,
        mblOnly,
        operatorId,
        branchId, mbl, serialNo } = this.form
      const params = {
        type: type,
        ETDStartDate: EtdDate ? new Date(EtdDate[0] + ' 00:00:00').getTime() : 0,
        ETDEndDate: EtdDate ? new Date(EtdDate[1] + ' 23:59:59').getTime() : 0,
        customStartDate: customDate ? new Date(customDate[0] + ' 00:00:00').getTime() : 0,
        customEndDate: customDate ? new Date(customDate[1] + ' 23:59:59').getTime() : 0,
        minDateCreated: dateCreated ? new Date(dateCreated[0] + ' 00:00:00').getTime() : 0,
        maxDateCreated: dateCreated ? new Date(dateCreated[1] + ' 23:59:59').getTime() : 0,
        jobState: jobState.join(','),
        jobNo,
        mblOnly,
        operatorId,
        mbl,
        branchId: branchId.join(','),
        sessionId: this.$store.getters.token
      }
      if (type === 'SE' || type === 'SI') {
        params.serialNo = serialNo
      }
      this.loading = getLoading()
      exportOrderCount(params).then(res => {
        this.countResult = res.data
        this.startExport(params)
      }).finally(() => {
        if (this.loading) {
          this.loading.close()
        }
      })
    },
    startExport(params) {
      this.loading = getLoading()
      this.fileFlagNo = uuidv4().replace(/\-/g, '')
      exportOrder({ ...params, fileFlagNo: this.fileFlagNo }).then(res => {
        convertResToBlob(res)
      }).then(() => {
        const { matchCount, dismatchCount } = this.countResult
        const h = this.$createElement
        const node = []
        node.push(h('p', null, this.$t('SystemDocking.TotalRecordsMeetTheConditions', [matchCount])))
        node.push(h('p', null, this.$t('SystemDocking.N0TheConditionsAndExported', [dismatchCount])))
        node.push(h('div', { style: 'margin:5px 0;text-align:right', attrs: {
          class: 'blue'
        }}, [
          h('a', { on: { click: this.downloadResult }}, this.$t('SystemDocking.DownloadExportResults'))
        ]))
        const message = h('div', null, node)
        const { type } = this.form
        let title = ''
        switch (type) {
          case 'AI':
            title = this.$t('SystemDocking.EnterAirCargoImport')
            break
          case 'AE':
            title = this.$t('SystemDocking.EnterAirExport')
            break
          case 'SI':
            title = this.$t('SystemDocking.EnterSeaCargoImport')
            break
          case 'SE':
            title = this.$t('SystemDocking.EnterOceanExport')
            break
        }
        this.$confirm(message, this.$t('SystemDocking.DownloadComplete'), {
          cancelButtonText: this.$t('SystemDocking.Return'),
          confirmButtonText: title,
          showConfirmButton: type === 'SE',
          closeOnClickModal: false,
          type: 'success'
        }).then(() => {
          switch (type) {
            case 'AI':
              this.$router.push({ name: 'AiBooking' })
              break
            case 'AE':
              this.$router.push({ name: 'AeBooking' })
              break
            case 'SI':
              this.$router.push({ name: 'SiBooking' })
              break
            case 'SE':
              this.$router.push({ name: 'SeaBooking' })
              break
          }
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    async downloadResult() {
      const { fileFlagNo } = this
      const res = await getFileId(fileFlagNo)
      if (res.data) {
        await cache.load(cacheName.USER, cacheName.CONFIG)
        // const storageUrl = cache.config.get('StorageURL')
        const url = `${URL.common.findByFileId}/${res.data}?sessionId=${this.$store.getters.token}`
        const el = document.createElement('a')
        document.body.appendChild(el)
        el.href = url
        el.target = '_blank'
        el.click()
        document.body.removeChild(el)
      }
    }
  }
}
</script>

<style lang="scss">
.kef-export-order{
  .el-radio-group {
    .el-radio {
      margin-right: 10px;
    }
  }
}
</style>
